<template>
    <div>
        <vue-form class="form-horizontal form-validation" :state="formstate" @submit.prevent="onSubmit">
            <b-row class='toolbar-ptc'>
                <b-col>
                    <router-link :to="{ name: 'coupon_exchange_list', params: {queryTab0: $route.params.queryTab0, querySaleNow: $route.params.querySaleNow, querySaleSchedule: $route.params.querySaleSchedule, queryTab1: $route.params.queryTab1, queryTab2: $route.params.queryTab2, modelTab: $route.params.modelTab, collapse: $route.params.collapse} }" class="btn btn-ptc1" tag="button">返回</router-link>
                </b-col>
                <b-col class='text-center title'>點數兌換券上架 / 商品券上架 / 編輯</b-col>
                <b-col class='text-right'>
                    <button type="submit" class="btn btn-save" @click='checkModelByOpen(1)' v-if='FunctionPermission > 1'>儲存</button>
                    <button v-if='this.modelTab==0 && this.FunctionPermission > 2' type="submit" class="btn btn-publish" @click='checkModelByOpen(2)'>發佈</button>
                </b-col>
            </b-row>
            <div id="func-content">
                <div class='contact-page'>
                    <b-modal ref='checkModel' hide-footer :title='this.checkModelTitle'>
                        <b-container fluid>
                            <form>
                                <div class='row mt-3' style='text-align:center;'>
                                    <label class='control-label' v-if='this.row.editSaleDay_E !== "" && this.row.editSaleDay_E < this.nowDate()'>確認<span style="color: #ff0000">{{this.checkModelTitle}}</span>「{{this.row.editTicketName}}」?</label>
                                    <label class='control-label' v-else>確認{{this.checkModelTitle}}「{{this.row.editTicketName}}」?</label>
                                </div>
                                <div class='float-right'>
                                    <b-btn variant='primary' @click='edit()'>確認</b-btn>
                                    <b-btn variant='secondary' @click='checkModelByCancel'>取消</b-btn>
                                </div>
                            </form>
                        </b-container>
                    </b-modal>
                    <div class='row'>
                        <div class='col-lg-12'>
                            <b-card class='bg-warning-card'>
                                <div class='row'>
                                    <b-container fluid>
                                        <form>
                                            <div class='row mb-3'>
                                                <label class='control-label col-md-3'>上傳圖片：</label>
                                                <div class='col-md-7'>
                                                    <input :disabled='(this.modelTab != 0 && row.editSaleDay_S <= nowDate())' type='file' class='upload_input' accept="image/*" id='editPic' multiple @change='edithandleFileChange' ref='editinputer'>
                                                    <label class='upload_block' for='editPic'>
                                                        <span class='upload_icon'>➕</span>
                                                        <img class='upload_img' v-if="row.editdataUrl != undefined" :src='file==undefined? row.editdataUrl : row.editdataUrl' />
                                                    </label>
                                                    <div class="text-danger" style="padding: 0.3rem" v-if="v_dataUrlMsg != ''">{{v_dataUrlMsg}}</div>
                                                    <div class='text-red' style='color:#FF0000;'>※限制上傳一張圖片，建議尺寸為156x156，內容建議顯示於寬x高120x156</div>
                                                </div>
                                            </div>
                                            <div class='row mb-3' v-show='modelTab != 0'>
                                                <label class='control-label col-md-3'>券別ID：</label>
                                                <div class='col-md-7'>
                                                    <input disabled type='text' class='form-control' v-model='row.editCode' placeholder='ID'>
                                                </div>
                                            </div>
                                            <div class='row mb-3'>
                                              <label class='control-label col-md-3'>是否為贈卷用：</label>
                                              <div class='col-md-9'>
                                                <toggle-button v-model="row.appSwap" :sync="true" :height=30 :width=60 disabled
                                                               style="font-size: 14px;" :labels="{checked: '否', unchecked: '是'}" :color="{checked: '#dc6460', unchecked: '#09BD8F'}" />
                                              </div>
                                            </div>

                                            <!-- 是否允許轉贈（allowTransfer） -->
                                            <div class='row mb-3'>
                                              <label class='control-label col-md-3'>是否允許會員互相轉贈：</label>
                                              <div class='col-md-9'>
                                                <toggle-button
                                                  v-model="row.allowTransfer"
                                                  :sync="true"
                                                  :height="30"
                                                  :width="60"
                                                  disabled
                                                  style="font-size: 14px;"
                                                  :labels="{ checked: '是', unchecked: '否' }"
                                                  :color="{ checked: '#09BD8F', unchecked: '#dc6460' }"
                                                />
                                              </div>
                                            </div>
                                            <div class='row mb-3' v-show="row.appSwap==true">
                                                <label class='control-label col-md-3'>APP分類：</label>
                                                <div class='col-md-7'>
                                                    <validate tag="div">
                                                        <select :disabled='this.modelTab != 0' id='editAppType' name='editAppType' class='form-control' v-model='row.editAppType' :required='this.modelTab == 0'>
                                                            <option disabled value='0'>請選擇</option>
                                                            <option v-for='x in listAppType' v-bind:value='x.id' :key="x.id">{{x.name}}</option>
                                                        </select>
                                                    </validate>
                                                </div>
                                            </div>
                                            <div class='row mb-3'>
                                                <label class='control-label col-md-3'>票券名稱：</label>
                                                <div class='col-md-7'>
                                                    <validate tag="div">
                                                        <input type='text' name='editTicketName' class='form-control' v-model.trim='row.editTicketName' placeholder='請輸入票券名稱' maxlength="30" :required='this.modelTab == 0'>
                                                        <field-messages name="editTicketName" show="$invalid && $submitted" class="text-danger">
                                                            <div slot="required">請輸入票券名稱</div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                            </div>
                                            <div class='row mb-3'>
                                                <label class='control-label col-md-3'>票券類別：</label>
                                                <div class='col-md-7'>
                                                    <validate tag="div">
                                                        <select :disabled='this.modelTab != 0' id='editTicketType' name='editTicketType' class='form-control' v-model='row.editTicketType' @change="onTicketTypeChange" :required='this.modelTab == 0'>
                                                            <option disabled value=''>請選擇</option>
                                                            <option v-for='x in listTicketType' v-bind:value='x.code+x.id' :key="x.code+x.id">{{x.name}}</option>
                                                        </select>
                                                        <field-messages name="editTicketType" show="$invalid && $submitted" class="text-danger">
                                                            <div slot="required">請選擇票券類別</div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                            </div>
                                            <div class='row mb-3'>
                                                <label class='control-label col-md-3'>發行型態：</label>
                                                <div class='col-md-8'>
                                                    <table>
                                                        <tr>
                                                            <td>
                                                                <input :disabled='this.modelTab != 0' type='radio' id='editTicketSpecies1' value=1 v-model='row.editTicketSpecies' @change="row.isFree = false">
                                                                <label for='editTicketSpecies1' v-show="row.appSwap==true" >常態</label>
                                                                <label for='editTicketSpecies1' v-show="row.appSwap==false" >票券有效天數</label>
                                                            </td>
                                                            <td>
                                                                <validate>
                                                                    <input :disabled='!(this.modelTab == 0 && row.editTicketSpecies == 1)' type='number' min=0 max=99999 v-on:input="row.editTicketSpeciesDay = validNumberLen($event, 5)" name='editTicketSpeciesDay' class='form-control' placeholder='請輸入兌換後可使用天數' v-model='row.editTicketSpeciesDay' :required='this.modelTab == 0 && this.row.editTicketSpecies == 1'>
                                                                    <field-messages name="editTicketSpeciesDay" show="$invalid && $submitted" class="text-danger">
                                                                        <div v-if='this.v_editTicketSpeciesDayMsg == ""' slot="required">請輸入天數</div>
                                                                    </field-messages>
                                                                    <div class="text-danger" style="padding: 0.3rem" v-show="row.editTicketSpecies == 1 && this.v_editTicketSpeciesDayMsg != ''">{{this.v_editTicketSpeciesDayMsg}}</div>
                                                                </validate>
                                                            </td>
                                                            <td><label class='control-label'>天</label></td>
                                                        </tr>
                                                        <tr v-show="row.appSwap==true">
                                                            <td>
                                                                <input :disabled='this.modelTab != 0' type='radio' id='editTicketSpecies2' value=2 v-model='row.editTicketSpecies'>
                                                                <label for='editTicketSpecies2'>限量</label>
                                                            </td>
                                                            <td>
                                                                <validate>
                                                                    <input :disabled='!(this.modelTab == 0 && row.editTicketSpecies == 2)' type='number' min=0 max=99999 name='editTicketSpeciesQty' class='form-control' placeholder='請輸入限量張數' v-on:input="row.editTicketSpeciesQty = validNumberLen($event, 5)" v-model='row.editTicketSpeciesQty' :required='this.modelTab == 0 && this.row.editTicketSpecies == 2'>
                                                                    <field-messages name="editTicketSpeciesQty" show="$invalid && $submitted" class="text-danger">
                                                                      <div v-if='this.v_editTicketSpeciesQtyMsg == ""' slot="required">請輸入張數</div>
                                                                    </field-messages>
                                                                    <div class="text-danger" style="padding: 0.3rem" v-show="row.editTicketSpecies == 2 && this.v_editTicketSpeciesQtyMsg != ''">{{this.v_editTicketSpeciesQtyMsg}}</div>
                                                                </validate>
                                                            </td>
                                                            <td><label class='control-label' style="padding-right:20px">張 (販售總數)</label></td>
                                                            <td >
                                                              <label class='control-label'>免費</label>
                                                              <toggle-button :disabled="!(this.modelTab == 0 && row.editTicketSpecies == 2)" v-model="row.isFree" :sync="true" :height=30 :width=60 style="font-size: 14px;" :labels="{checked: '是', unchecked: '否'}" :color="{checked: '#09BD8F', unchecked: '#dc6460'}" @change="onChangeFree" />
                                                            </td>
                                                        </tr>
                                                        <tr v-if="row.editTicketSpecies==2">
                                                            <td>
                                                            </td>
                                                            <td colspan='3'>
                                                              <table>
                                                                <tr>
                                                                  <td colspan='3'>
                                                                    <input type='radio' name='rdoLimitBuy' value=1 :disabled="!(this.modelTab == 0 && row.editTicketSpecies == 2)" v-model='row.editTicketBuy'>
                                                                    <label>會員限兌換一次一張</label>
                                                                  </td>
                                                                </tr>
                                                                <tr>
                                                                  <td>
                                                                    <input type='radio' name='rdoLimitBuy' value=2 :disabled="!(this.modelTab == 0 && row.editTicketSpecies == 2)" v-model='row.editTicketBuy'>
                                                                    <label>會員每日限購</label>
                                                                  </td>
                                                                  <td>
                                                                    <validate>
                                                                        <input :disabled='!(this.modelTab == 0 && row.editTicketSpecies == 2 && row.editTicketBuy == 2)' type='number' min=0 max=99999 name='editTicketBuyQty' class='form-control' placeholder='請輸入限購張數' v-on:input="row.editTicketBuyQty = validNumberLen($event, 5)" v-model='row.editTicketBuyQty' :required='this.modelTab == 0 && this.row.editTicketSpecies == 2 && this.row.editTicketBuy == 2'>
                                                                        <field-messages name="editTicketBuyQty" show="$invalid && $submitted" class="text-danger">
                                                                          <div v-if='this.v_editTicketBuyQtyMsg == ""' slot="required">請輸入張數</div>
                                                                        </field-messages>
                                                                        <div class="text-danger" style="padding: 0.3rem" v-show="row.editTicketSpecies == 2 && this.v_editTicketBuyQtyMsg != ''">{{this.v_editTicketBuyQtyMsg}}</div>
                                                                    </validate>
                                                                  </td>
                                                                  <td>
                                                                      <label class='control-label' style="padding-right:20px">張</label>
                                                                  </td>
                                                                </tr>
                                                              </table>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class='row mb-3'>
                                                <label class='control-label col-md-3'>上架時間：</label>
                                                <div class='col-md-3'>
                                                    <validate tag="div">
                                                        <input :disabled='this.modelTab != 0' type='date' name='editSaleDay_S' class='form-control' @change="row.editUseDay_S = $event.target.value" v-model='row.editSaleDay_S' :max="max_date" :required='this.modelTab == 0'>
                                                        <field-messages name="editSaleDay_S" show="$invalid && $submitted" class="text-danger">
                                                            <div v-if='this.v_SaleDayMsg == ""' slot="required">&nbsp;請輸入正確的日期格式(起)</div>
                                                        </field-messages>
                                                        <div class="text-danger" style="padding: 0.3rem" v-show="this.v_SaleDayMsg != ''">{{this.v_SaleDayMsg}}</div>
                                                    </validate>
                                                </div>
                                                <label class='control-label'></label>
                                                <div class='col-md-3'>
                                                    <validate tag="div">
                                                      <input :disabled='this.modelTab != 0' type='time' name='editSaleDay_STime' class='form-control' v-model='row.editSaleDay_STime' :required='this.modelTab == 0'>
                                                    </validate>
                                                </div>
                                            </div>
                                            <div class='row mb-3'>
                                                <label class='control-label col-md-3'>下架時間：</label>
                                                <div class='col-md-3'>
                                                    <validate tag="div">
                                                        <input type='date' name='editSaleDay_E' class='form-control' v-model='row.editSaleDay_E' :max="max_date" required>
                                                        <field-messages name="editSaleDay_E" show="$invalid && $submitted" class="text-danger">
                                                            <div slot="required">請輸入正確的日期格式(迄)</div>
                                                        </field-messages>
                                                        <div class="text-danger" style="padding: 0.3rem" v-show="this.v_SaleDayEMsg != ''">{{this.v_SaleDayEMsg}}</div>
                                                    </validate>
                                                </div>
                                                <label class='control-label'></label>
                                                <div class='col-md-3'>
                                                    <validate tag="div">
                                                      <input type='time' name='editSaleDay_ETime' class='form-control' v-model='row.editSaleDay_ETime' :required='this.modelTab == 0'>
                                                    </validate>
                                                </div>
                                            </div>
                                            <div class='row mb-3' v-show="row.appSwap==true">
                                                <label class='control-label col-md-3'>上架顯示週期：</label>
                                                <div class='col-md-7'>
                                                  <validate tag="div">
                                                    <b-form-group>
                                                      <b-form-checkbox-group v-model="row.week" :options="optionsWeek"></b-form-checkbox-group>
                                                    </b-form-group>
                                                    <div class="text-danger" v-show="this.v_editWeekMsg != ''">{{this.v_editWeekMsg}}</div>
                                                  </validate>
                                                </div>
                                            </div>
                                            <div class='row mb-3' v-show='row.editTicketSpecies==2'>
                                                <label class='control-label col-md-3'>兌換期間：</label>
                                                <div class='col-md-3'>
                                                    <validate tag="div">
                                                        <input disabled type='date' name='editUseDay_S' class='form-control' v-model='row.editUseDay_S' :max="max_date" :required='this.modelTab == 0 && this.row.editTicketSpecies==2'>
                                                        <field-messages name="editUseDay_S" show="$invalid && $submitted" class="text-danger">
                                                            <div v-if='this.v_UseDayMsg == ""' slot="required">請選擇上架日(起)</div>
                                                        </field-messages>
                                                        <div class="text-danger" style="padding: 0.3rem" v-show="this.v_UseDayMsg != ''">{{this.v_UseDayMsg}}</div>
                                                    </validate>
                                                </div>
                                                <label class='control-label'>至</label>
                                                <div class='col-md-3'>
                                                    <validate tag="div">
                                                        <input :disabled='this.modelTab != 0' type='date' name='editUseDay_E' class='form-control' v-model='row.editUseDay_E' :max="max_date" :required='this.modelTab == 0 && this.row.editTicketSpecies==2'>
                                                        <field-messages name="editUseDay_E" show="$invalid && $submitted" class="text-danger">
                                                            <div v-if='this.v_UseDayEMsg == ""' slot="required">請輸入正確的日期格式(迄)</div>
                                                        </field-messages>
                                                        <div class="text-danger" style="padding: 0.3rem" v-show="this.v_UseDayEMsg != ''">{{this.v_UseDayEMsg}}</div>
                                                    </validate>
                                                </div>
                                            </div>
                                            <hr>
                                            <div class='row mb-3'>
                                                <label class='control-label col-md-3'>兌換規則：</label>
                                                <div class='col-md-8'>
                                                    <table>
                                                        <tr>
                                                            <td v-show="row.appSwap==true">
                                                                <label class='control-label'>兌換點數</label>
                                                            </td>
                                                            <td v-show="row.appSwap==true">
                                                                <validate tag="div">
                                                                  <input :disabled='this.modelTab != 0 || (row.isFree && row.editTicketSpecies==2)' type='number' name='editPoint' class='form-control' min=0 max=99999 v-on:input="row.editPoint = validNumberLen($event, 5)" v-model='row.editPoint' :required='this.modelTab == 0'>
                                                                  <div class="text-danger" style="padding: 0.3rem" v-show="this.v_editPointMsg != ''">{{this.v_editPointMsg}}</div>
                                                                </validate>
                                                            </td>
                                                            <td>
                                                                <label v-if='row.editTicketType.substr(0,3) === "A01"' class='control-label'>折抵</label>
                                                                <label v-if='row.editTicketType.substr(0,3) === "C01"' class='control-label'>折扣</label>
                                                            </td>
                                                            <td v-if='row.editTicketType.substr(0,3) != "G01" && row.editTicketType.substr(0,3) != ""'>
                                                                <validate tag="div">
                                                                    <input :disabled='this.modelTab != 0' type='number' name='editMoney' class='form-control' min=0 :max='row.editTicketType.substr(0,3)=="C01"?1 : 9999' v-on:input="row.editMoney = validNumberLen($event, 4)" v-model='row.editMoney' :required='this.row.editTicketType.substr(0,3) != "G01" && this.modelTab == 0'>
                                                                    <field-messages name="editMoney" show="$invalid && $submitted" class="text-danger">
                                                                        <div v-if='this.v_editMoneyMsg==""' slot="required">請輸入折扣</div>
                                                                    </field-messages>
                                                                    <div class="text-danger" style="padding: 0.3rem" v-show="this.v_editMoneyMsg != ''">{{this.v_editMoneyMsg}}</div>
                                                                </validate>
                                                            </td>
                                                            <td v-if='row.editTicketType.substr(0,3) == "G01"'>
                                                                <input :disabled='this.modelTab != 0' type='text' name='editText' class='form-control' v-model.trim='row.editText' placeholder='請輸入兌換活動' maxlength="30" :required='this.row.editTicketType === "G01" && this.modelTab === 0'>
                                                            </td>
                                                            <td>
                                                                <label v-if='row.editTicketType.substr(0,3) === "A01"' class='control-label'>元</label>
                                                                <label v-if='row.editTicketType.substr(0,3) === "C01"' class='control-label'>EX:9折=0.9</label>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class='row mb-3'>
                                              <label class='control-label col-md-3'>票券使用管道：</label>
                                              <div class='col-md-9'>
                                                <input type='radio' name='rdoUseType' value=1 v-model='row.editUseType' :disabled='this.modelTab != 0 || row.editTicketType.substr(0,3) === "C01"'>
                                                <label>全部</label>
                                                <input type='radio' name='rdoUseType' value=2 v-model='row.editUseType' :disabled='this.modelTab != 0 || row.editTicketType.substr(0,3) === "C01"'>
                                                <label>POS</label>
                                                <input type='radio' name='rdoUseType' value=3 v-model='row.editUseType' :disabled='this.modelTab != 0'>
                                                <label>APP</label>
                                              </div>
                                          </div>
                                        <div class='row mb-3' v-if="row.editTicketType.substr(0,3)=='G01'">
                                            <label class='control-label col-md-3'>票券使用品牌：</label>
                                            <div class='col-md-4'>
                                              <select
                                                id="queryBrandsCode"
                                                name="queryBrandsCode"
                                                class="form-control"
                                                v-model="row.queryBrandsCode"
                                                @change="onQueryBrandsCodeChange"
                                                :disabled='this.modelTab != 0'
                                              >
                                              <option
                                                v-for="x in selectListBrands"
                                                v-bind:value="x.Code"
                                                :key="x.Code"
                                              >{{x.Text}}</option>
                                              </select>
                                            </div>
                                        </div>
                                          <div class='row mb-3' v-show="row.editUseType!=2">
                                              <label class='control-label col-md-3'>APP線上訂餐規則：</label>
                                              <div class='col-md-9'>
                                                  <table>
                                                      <tr v-if="row.editTicketType.substr(0,3)=='G01' && row.editUseType!=2">
                                                          <td>
                                                              <label class='control-label'>優惠規則</label>
                                                          </td>
                                                          <td>
                                                            <validate tag="div">
                                                                <select id='Input_TicketRule' name='Input_TicketRule' class='form-control' v-model='row.editTicketRule' @change="checkSaleDiscount(false)" :disabled='this.modelTab != 0' required>
                                                                    <option disabled value=''>請選擇</option>
                                                                    <option value='1'>買A送B</option>
                                                                    <option value='2'>商品折價</option>
                                                                    <option value='3'>商品特價</option>
                                                                    <option value='4'>商品第二件N折</option>
                                                                </select>
                                                                <field-messages name="Input_TicketRule" show="$invalid && $submitted" class="text-danger">
                                                                    <div slot="required">請選擇優惠規則</div>
                                                                </field-messages>
                                                            </validate>
                                                          </td>
                                                      </tr>
                                                      <tr v-if="row.editTicketType.substr(0,3)=='G01' && row.editTicketRule!=''">
                                                          <td>
                                                              <label class='control-label'>買</label>
                                                          </td>
                                                          <td>
                                                            <multiselect v-model="row.editProduct_A" :options="productsA" :multiple="false" :custom-label="nameWithLang" group-values="Detail" :show-labels="false" group-label="Attribute" :group-select="false" placeholder="請選擇" track-by="Name" label="Name" :disabled='this.modelTab != 0'>
                                                              <span slot="noResult">查無資料</span>
                                                            </multiselect>
                                                            <div class="text-danger" v-if="row.editTicketType.substr(0,3)=='G01' && (row.editTicketRule== '2' || row.editTicketRule=='3' || row.editTicketRule=='4') && !row.editProduct_A && this.v_Product_A != ''">{{v_Product_A}}</div>
                                                          </td>
                                                      </tr>
                                                      <tr v-if="row.editTicketType.substr(0,3)=='G01' && row.editTicketRule=='1'">
                                                          <td>
                                                            <label class='control-label'>送</label>
                                                          </td>
                                                          <td>
                                                            <multiselect v-model="row.editProduct_B" :options="productsB" :multiple="false" :custom-label="nameWithLang" group-values="Detail" :show-labels="false" group-label="Attribute" :group-select="false" placeholder="請選擇" track-by="Name" label="Name" :disabled='this.modelTab != 0'>
                                                              <span slot="noResult">查無資料</span>
                                                            </multiselect>
                                                            <div class="text-danger" v-if="row.editTicketType.substr(0,3)=='G01' && row.editTicketRule=='1' && (!row.editProduct_A || !row.editProduct_B) && v_Product_B != ''">{{v_Product_B}}</div>
                                                          </td>
                                                          <td><div class='text-red' style='color:#FF0000;'>※如要送加料，請選擇A商品所屬的加料品，否則B區商品將不會傳給POS。</div></td>
                                                      </tr>
                                                      <tr v-if="row.editTicketType.substr(0,3)=='G01' && !(row.editTicketRule=='' || row.editTicketRule=='1')">
                                                          <td>
                                                              <label class='control-label' v-show="row.editTicketRule=='2'">折價</label>
                                                              <label class='control-label' v-show="row.editTicketRule=='3'">特價</label>
                                                              <label class='control-label' v-show="row.editTicketRule=='4'">折扣</label>
                                                          </td>
                                                          <td>
                                                              <input type='number' class='form-control' name="InputSaleDiscount" placeholder='請輸入數值' min=0 :max='row.editTicketRule=="4"?1 : 999' v-on:input="row.editSaleDiscount = validNumberLen($event, 5)" v-model='row.editSaleDiscount' :disabled='this.modelTab != 0'>
                                                              <div class="text-danger" style="padding: 0.3rem" v-show="row.editTicketType.substr(0,3)=='G01' && (row.editTicketRule=='2'||row.editTicketRule == '3'||row.editTicketRule=='4') && this.v_SaleDiscount != ''">{{this.v_SaleDiscount}}</div>
                                                          </td>
                                                          <td>
                                                              <label class='control-label' v-show="row.editTicketRule!='2'">元</label>
                                                              <label class='control-label' v-show="row.editTicketRule=='4'">折 EX:9折=0.9</label>
                                                          </td>
                                                      </tr>
                                                      <tr v-if="row.editTicketType.substr(0,3)!='G01'">
                                                          <td>
                                                              <label class='control-label'>滿</label>
                                                          </td>
                                                          <td>
                                                                <input type='number' class='form-control' name="InputSaleDiscount" placeholder='請輸入數值' min=0 max=9999 v-on:input="row.editUseAmount = validNumberLen($event, 4)" v-model='row.editUseAmount' :disabled='this.modelTab != 0'>
                                                                <div class="text-danger" style="padding: 0.3rem" v-show="this.v_useAmount != ''">{{this.v_useAmount}}</div>
                                                          </td>
                                                          <td>
                                                              <label class='control-label'>元使用</label>
                                                          </td>
                                                      </tr>
                                                  </table>
                                              </div>
                                          </div>
                                          <div class='row mb-3'>
                                            <label class='control-label col-md-3'>票券使用模式：</label>
                                            <div class='col-md-9'>
                                              <input type='radio' name='rdoStoreMode' value=0 v-model='row.storeMode' @change="handleStoreModeChange">
                                              <label>指定品牌</label>
                                              <input type='radio' name='rdoStoreMode' value=1 v-model='row.storeMode' @change="handleStoreModeChange">
                                              <label>指定門市</label>
                                              <input type='radio' name='rdoStoreMode' value=2 v-model='row.storeMode' @change="handleStoreModeChange" :disabled="row.editTicketType.substr(0,3)=='G01'">
                                              <label>全品牌</label>
                                              <input hidden type="file" ref="fileInput" id="storeList" accept=".csv" @change="handleFileUpload()">
                                              <button type="button" class="btn btn-warning text-white ml-2" @click="handleResetStore()">清除已選門市</button>
                                              <div class="text-danger" style="padding: 0.3rem" v-if="v_StoreMode != ''">{{v_StoreMode}}</div>
                                              <div class='col-md-3'>
                                                <p class="text-primary cursor_add_store" @click="addStoreShow()">{{showStoreWord}}</p>
                                              </div>
                                            </div>
                                          </div>
                                          <div class='row mb-3' v-if="row.editTicketType.substr(0,3)!=='G01'">
                                            <label class='control-label col-md-3'>票券使用品牌：</label>
                                            <div class='col-md-9'>
                                              <b-form-checkbox-group v-model="row.selectBrands" style="overflow: auto" stacked>
                                                <b-form-checkbox v-for="x in selectListBrands" :value="x.Code" :key="x.Code" :disabled="row.storeMode==1||row.storeMode==2">{{x.Text}}</b-form-checkbox>
                                              </b-form-checkbox-group>
                                              <div class="text-danger" style="padding: 0.3rem" v-if="v_BrandMsg != ''">{{v_BrandMsg}}</div>
                                            </div>
                                          </div>
                                          <div class='row mb-3'>
                                            <label class='control-label col-md-3'>票券使用時段：<br />(最多24，0~0為全時段)</label>
                                            <div class='col-md-2'>
                                              <validate tag="div">
                                                <input type='number' name='Input_UseStartAt' class='form-control' v-model='row.useStartAt' min="0" max="24">
                                              </validate>
                                            </div>點
                                            <label class='control-label'>至</label>
                                            <div class='col-md-2'>
                                              <validate tag="div">
                                                <input type='number' name='Input_UseEndAt' class='form-control' v-model='row.useEndAt' min="0" max="24">
                                              </validate>
                                            </div>點
                                            <div class="text-danger" style="padding: 0.3rem" v-if="v_UseTime != ''">{{v_UseTime}}</div>
                                          </div>
                                          <div class='row mb-3'>
                                              <label class='control-label col-md-3'>票券平假日使用設定：</label>
                                              <div class='col-md-9'>
                                                <input type='radio' name='rdoDayMode' value=0 v-model='row.dayMode'>
                                                <label>不分平假日</label>
                                                <input type='radio' name='rdoDayMode' value=1 v-model='row.dayMode'>
                                                <label>平日</label>
                                                <input type='radio' name='rdoDayMode' value=2 v-model='row.dayMode'>
                                                <label>假日</label>
                                              </div>
                                          </div>
                                          <div class="row mb-3">
                                            <label class='control-label col-md-3' for="memo">票券提示文字：</label>
                                            <validate tag="div" class="col-md-3">
                                              <input v-model="row.memo" id="memo" name="Input_Memo" type="text" autofocus  class="form-control"/>
                                              <div class="text-danger" style="padding: 0.3rem" v-show="this.v_Memo != ''">{{this.v_Memo}}</div>
                                            </validate>
                                          </div>
                                          <div class="row mb-3">
                                            <label class='control-label col-md-3' for="pointSubsidy">票券補貼點數：</label>
                                            <div class='col-md-3'>
                                              <input type='number' name='Input_PointSubsidy' class='form-control' v-model='row.pointSubsidy' min="0" :disabled='(this.modelTab != 0 && dbPointSubsidy != 0)'>
                                            </div>
                                          </div>
                                          <div class='row mb-3'>
                                              <label class='control-label col-md-3'>備註條款：</label>
                                              <div class='col-md-9'>
                                                <vue-editor v-model="repl_content" :editor-toolbar="customToolbar"></vue-editor>
                                              </div>
                                          </div>
                                          <div class='row mb-3'>
                                              <label class='control-label col-md-3'>異動人員：</label>
                                              <div class='col-md-3'>
                                                  <input disabled type='text' class='form-control' v-model='row.editUpdId'>
                                              </div>
                                              <label class='control-label'>異動時間：</label>
                                              <div class='col-md-3'>
                                                  <input disabled type='text' class='form-control' v-model='row.editUpdTime'>
                                              </div>
                                          </div>
                                          <div class='row mb-3' v-if='this.modelTab != 0'>
                                              <label class='control-label col-md-3'>發佈人員：</label>
                                              <div class='col-md-3'>
                                                  <input disabled type='text' class='form-control' v-model='row.editCheckUpdId'>
                                              </div>
                                              <label class='control-label'>發佈時間：</label>
                                              <div class='col-md-3'>
                                                  <input disabled type='text' class='form-control' v-model='row.editCheckUpdTime'>
                                              </div>
                                          </div>
                                        </form>
                                    </b-container>
                                </div>
                            </b-card>
                        </div>
                    </div>
                </div>
            </div>
            <b-modal size='lg' ref="addStore" hide-footer title="新增門市">
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">地區：</label>
                <div class="col-md-3">
                  <multiselect
                    id="city"
                    v-model="city"
                    :options="Array.from(citylist.keys())"
                    @input="cityChange"
                    :show-labels="false"
                    :multiple="false"
                    placeholder="請選擇"
                  >
                  <template slot="option" slot-scope="{ option }">
                    <span>
                      {{ option }}
                      <i class="fa fa-check" v-if="selectedCity.includes(option)" style="margin-left: 5px;"></i>
                    </span>
                  </template>
                  <span slot="noResult">查無資料</span>
                 </multiselect>
                </div>
                <label class="control-label col-md-2 mt-2 text-right">門市：</label>
                <div class="col-md-4">
                  <multiselect v-model="store" :options="storelist" :multiple="false" :custom-label="nameWithLang" :placeholder="placeholderText" label="Name" track-by="Name" :show-labels="false" :disabled="isDisable">
                    <span slot="noResult">查無資料</span>
                  </multiselect>
                </div>
                <div>
                  <button type="button" class="btn btn-warning text-white" @click="handleAddStore()" :disabled="isDisable">新增</button>
                </div>
              </div>
              <div class="d-flex flex-row-reverse mt-3 mr-3">
                <div>
                  <i class="fa fa-question-circle" style="cursor: pointer;" @click="$refs.importFileDesc.show()"></i>
                  <button type="button" class="btn btn-warning text-white ml-2" @click="() => {this.$refs.fileInput.click()}">檔案匯入門市</button>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="p-4 box-shadow" header="Form Elements">
                    <table id="mytable" class="table table-bordred table-striped mt-3 table-break">
                      <thead>
                          <tr>
                              <th width="10%">項次</th>
                              <th width="20%">地區</th>
                              <th width="35%">品牌_門市名稱</th>
                              <th width="25%">門市代碼</th>
                              <th width="10%">刪除</th>
                          </tr>
                          <tr v-for="v in showStoreList" :key="v.ID">
                              <td>{{v.Seq}}</td>
                              <td>{{v.City}}</td>
                              <td>{{v.Name}}</td>
                              <td>{{v.Code}}</td>
                              <td><button class='btn-circle btn-circle-ptc1' @click="handleDelStore(v.ID)"><span class='fas fa-trash-alt' title="刪除"></span></button></td>
                          </tr>
                      </thead>
                    </table>
                    <div>
                        <div class="row" style="padding: 0 1rem">
                            <b-pagination size="md" :total-rows="model1.totalrows" v-model="model1.currentPage" :per-page="model1.rows" @change="getAddStoreList"></b-pagination>
                            <label style="margin:8px">{{model1.startRowNum}}到{{model1.endRowNum}}，總共 {{model1.totalrows}}筆</label>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
            <!-- 匯入檔案說明 -->
            <b-modal ref="importFileDesc" hide-footer title="匯入檔說明">
              <pre class="mb-0" style="font-size:16px">
檔案格式
1. 僅限csv檔。
2. 檔名不限。
3. 可多次匯入不同檔案。
4. 重複門市將自動排除。

內容限制
1.僅需輸入門市代碼。
2.不可有空行(含最後一行)。
3.單次匯入上限為2000筆。
              </pre>
              <img src="/static/StoresImportSample.png" class="img-fluid"/>
            </b-modal>
        </vue-form>
    </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { API_URL, fileUploadMaxSize } from '@/store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import { VueEditor } from 'vue2-editor'
import Multiselect from 'vue-multiselect'
import miniToastr from 'mini-toastr'
import ToggleButton from 'vue-js-toggle-button'
miniToastr.init()
Vue.use(ToggleButton)
export default {
  components: {
    Multiselect,
    VueEditor
  },
  mounted () {
  },
  data () {
    return {
      formstate: {}, // 驗證用
      file: undefined,
      max_date: '9999-12-31',
      productsA: [],
      productsB: [],
      row: {
        editId: '',
        editCode: '',
        editAppType: '',
        editTicketName: '',
        editTicketType: '',
        editTicketSpecies: 1,
        editTicketSpeciesDay: 30,
        editTicketSpeciesQty: 0,
        editTicketBuy: 1,
        editTicketBuyQty: 1,
        editUseDay_S: '',
        editUseDay_E: '',
        editSaleDay_S: '',
        editSaleDay_E: '',
        editSaleDay_STime: '',
        editSaleDay_ETime: '',
        editPoint: '',
        editSaleMoney: 0,
        editTicketMoney: 0,
        editdataUrl: undefined,
        editMoney: 0,
        editText: '',
        editUpdId: '',
        editUpdTime: '',
        editCheckUpdId: '',
        editCheckUpdTime: '',
        editStatus: 0,
        content: '',
        statusDesc: '',
        updatedAt: '',
        isFree: false,
        week: [],
        editUseType: 1, // 使用管道
        editUseAmount: 0,
        editTicketRule: '', // 優惠規則
        editProduct_A: '',
        editProduct_B: '',
        editSaleDiscount: 0, // 銷售品折扣/金額
        appSwap: true,
        storeMode: 0,
        useStartAt: 0,
        useEndAt: 0,
        dayMode: 0,
        memo: '',
        pointSubsidy: 0,
        selectBrands: [],
        queryBrandsCode: '',
        allowTransfer: true,
      },
      dbPointSubsidy: 0,
      v_AppType: '',
      v_sale_sdate: '',
      v_sale_edate: '',
      v_Product_A: '',
      v_Product_B: '',
      v_SaleDiscount: '',
      v_useAmount: '',
      v_SaleDayMsg: '',
      v_SaleDayEMsg: '',
      v_UseDayMsg: '',
      v_UseDayEMsg: '',
      v_dataUrlMsg: '',
      v_editTicketSpeciesDayMsg: '',
      v_editTicketSpeciesQtyMsg: '',
      v_editTicketBuyQtyMsg: '',
      v_editMoneyMsg: '',
      v_editPointMsg: '',
      v_editWeekMsg: '',
      v_UseTime: '',
      v_Memo: '',
      v_StoreMode: '',
      modelTab: 0, // 0:待審核 1:上架 2:下架
      FunctionPermission: 0, // 功能權限
      apiUrl: API_URL,
      // --------------------
      checkModelType: 1, // 1儲存, 2:發佈
      checkModelTitle: '',
      // --------------------
      listAppType: [],
      listTicketType: [],
      optionsWeek: [
        { text: '一', value: 1 },
        { text: '二', value: 2 },
        { text: '三', value: 3 },
        { text: '四', value: 4 },
        { text: '五', value: 5 },
        { text: '六', value: 6 },
        { text: '日', value: 0 }
      ],
      citylist: new Map(), // 地區類別下拉
      selectedCity: [],
      selectedCityList: new Map(),
      city: '', // 地區
      store: { ID: 0, Code: '', Name: '' }, // 門市
      storelist: [{ ID: 0, Code: '', Name: '' }],
      addStoreList: [],
      showStoreList: [],
      addStoreAmount: 0,
      showStoreWord: '新增排除門市',
      model1: {
        currentPage: 1,
        totalrows: 0,
        rows: 10,
        startRowNum: 0,
        endRowNum: 0
      },
      repl_content: '',
      customToolbar: [
        //[{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote"],//, "code-block"
        [{ list: "ordered" }, { list: "bullet" }],//, { list: "check" }
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image"], //, "video", "formula"
        //[{ direction: "rtl" }],
        ["clean"]
      ],
      selectListBrands: [{ ID: 0, Code: '', Text: '' }],
      v_BrandMsg: ''
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F10') // 功能權限 帶入功能代碼
    this.querySelectListBrands()
    if (this.FunctionPermission >= 2) {
      this.query()
      // 抓取門市清單
      this.getpost()
      axios.post(API_URL + '/web/ticket/querydropdown')
        .then((response) => {
          this.listAppType = response.data.data.appcategory
          this.listTicketType = response.data.data.poscategory
          if (response.data.result === '0000') {
            var params = this.$route.params
            if (params.item === undefined) {
              this.$router.push({ name: 'coupon_exchange_list' })
              return
            }
            var hasDelete = false
            if (params.modelTab !== 0) {
              hasDelete = true
            }
            this.getAllProductsA(hasDelete,false)
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
        })
      //this.getAddStoreList(1)
    } else {
      if (this.FunctionPermission === 1) {
        this.$router.push({ name: 'coupon_exchange_list' })
      } else {
        this.$router.push({ name: 'name' })
      }
    }
  },
  methods: {
    checkSaleDiscount (check) {
      if (this.row.editUseType !== 2 && (check || this.formstate.$submitted)) {
        this.v_SaleDiscount = ''
        this.v_Product_A = ''
        this.v_Product_B = ''

        // 買A送B
        if (this.row.editTicketRule === '1' && (!this.row.editProduct_A || !this.row.editProduct_B)) {
          this.v_Product_B = '請輸入完整優惠規則'
        }
        if (this.row.editTicketRule === '2' || this.row.editTicketRule === '3' || this.row.editTicketRule === '4') {
          if (!this.row.editProduct_A) {
            this.v_Product_A = '請選擇品項'
          }
          // 商品折價
          if (this.row.editTicketRule === '2') {
            if (Number(this.row.editSaleDiscount) <= 0 || Number.isInteger(Number(this.row.editSaleDiscount) === false)) {
              this.v_SaleDiscount = '請輸入1~999的整數'
            }
          }
          // 商品特價
          if (this.row.editTicketRule === '3' && (Number(this.row.editSaleDiscount) < 0 || Number.isInteger(Number(this.row.editSaleDiscount) === false))) {
            this.v_SaleDiscount = '請輸入0~999的整數'
          }
          // 商品第二件N折
          if (this.row.editTicketRule === '4' && (!this.row.editSaleDiscount || (parseFloat(this.row.editSaleDiscount) > 1 || parseFloat(this.row.editSaleDiscount) < 0.01 || this.row.editSaleDiscount.split('.').length > 2 || (this.row.editSaleDiscount.split('.').length >= 2 && this.row.editSaleDiscount.split('.')[1].length > 2)))) {
            this.v_SaleDiscount = '請輸入0.01~1的數值(小數最多兩位)'
          }
        }
      }
    },
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    },
    validNumberLen (e, leng) {
      var value = e.target.value
      if (e.target.value.length > leng) {
        value = e.target.value.slice(0, leng)
      }
      return value
    },
    onChangeFree: function () {
      if (this.row.isFree === true) {
        this.row.editPoint = 0
      }
    },
    getAllProductsA (hasDelete,changeBrand) {
      this.$parent.Loading = true

      axios.post(API_URL + '/web/shopping/getallproducts/v1', {
        status: 1,
        hasDelete: hasDelete,
        hasExtra: false,
        hasCombo: false,
        brandCode: this.row.queryBrandsCode
      })
        .then((response) => {
          this.$parent.Loading = false
          if (response.data.result === '0000') {
            this.productsA = response.data.data
            this.getAllProductsB(hasDelete,changeBrand)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, 'A商品資料讀取異常')
        })
    },
    getAllProductsB (hasDelete,changeBrand) {
      this.$parent.Loading = true
      axios.post(API_URL + '/web/shopping/getallproducts/v1', {
        status: 1,
        hasDelete: hasDelete,
        hasExtra: true,
        hasCombo: false,
        brandCode: this.row.queryBrandsCode
      })
        .then((response) => {
          this.$parent.Loading = false
          if (response.data.result === '0000') {
            this.productsB = response.data.data
            //this.query()
            this.productValue(changeBrand)
/*             // 更新已新增門市清單
            const storeCodeList = this.addStoreList.map(store => store.Code)
            this.addStoreList = []
            this.citylist.forEach((stores, city) => {
              stores.forEach((store) => {
                if (storeCodeList.includes(store.Code)) {
                  let storeObj = {...store} // copy object
                  this.addStoreList.push(storeObj)
                  this.selectedCityList.get(city).push(storeObj)
                }
              })
              this.citylist.set(city, this.citylist.get(city).filter(store => !storeCodeList.includes(store.Code)))
            })
            this.cityChange()
            this.getAddStoreList(1) */
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, 'B商品資料讀取異常')
        })
    },
    query () {
      var params = this.$route.params
      if (params.item === undefined) {
        this.$router.push({ name: 'coupon_exchange_list' })
        return
      }
      console.log(params.item)
      var item = params.item
      this.modelTab = params.modelTab
      var applicableStartAt = ''
      var applicableEndAt = ''
      this.row.appSwap = item.appswap
      if (item.published === 2) {
        applicableStartAt = item.applicableStartAt.replace(/\//g, '-')
        applicableEndAt = item.applicableEndAt.replace(/\//g, '-')
      } else if (this.modelTab === 0 && item.published === 1) {
        applicableStartAt = item.enabledAt.replace(/\//g, '-')
      }
      var discount = 0
      if (item.posCategoryCode.substr(0, 3) !== 'G01') {
        discount = item.discount
      }
      this.row.editId = item.id
      this.row.editCode = item.code
      this.row.editAppType = item.appCategoryID
      this.row.editTicketName = item.name
      this.row.editTicketSpecies = item.published
      this.row.editTicketSpeciesDay = item.days
      this.row.editTicketSpeciesQty = item.amount
      this.row.editTicketType = item.posCategoryCode
      this.row.editSaleDay_S = item.enabledAt.replace(/\//g, '-')
      this.row.editSaleDay_E = item.disabledAt.replace(/\//g, '-')
      this.row.editSaleDay_STime = item.enabledAtTime
      this.row.editSaleDay_ETime = item.disabledAtTime
      this.row.editUseDay_S = applicableStartAt
      this.row.editUseDay_E = applicableEndAt
      this.row.editPoint = item.bonus
      this.row.editMoney = discount
      this.row.editText = item.text
      this.row.editUpdId = item.updatedName
      this.row.editUpdTime = item.updatedAt
      this.row.editCheckUpdId = item.releaseName
      this.row.editCheckUpdTime = item.releaseAt
      this.row.editdataUrl = item.imageURL
      this.row.editStatus = item.status
      this.repl_content = item.comment
      this.row.updatedAt = item.updatedAt
      this.row.isFree = item.isfree
      this.row.week = JSON.parse('[' + item.week + ']')
      this.row.editUseType = item.useType
      this.row.storeMode = item.storeMode
      this.addStoreList = item.storeList
      this.row.useStartAt = (item.useStartAt === '') ? 0 : parseInt(item.useStartAt.split(':')[0], 10)
      this.row.useEndAt = (item.useEndAt === '') ? 0 : parseInt(item.useEndAt.split(':')[0], 10)
      this.row.dayMode = item.dayMode
      this.row.memo = item.memo
      this.row.pointSubsidy = item.pointSubsidy
      this.dbPointSubsidy = item.pointSubsidy
      this.row.allowTransfer = item.allowTransfer
      if ( item.posCategoryCode.substr(0, 3) === 'G01') {
        this.row.queryBrandsCode = item.brandCodes[0]
      } else {
        this.row.selectBrands = item.brandCodes
      }

      if (Number(this.row.editTicketSpecies) === 2) {
        this.row.editTicketBuy = item.limitType
        this.row.editTicketBuyQty = item.limitQty
      }
      console.log('query'+this.addStoreList.length)
    },
    productValue (changeBrand) {
      var item = this.$route.params.item
      if (this.row.editUseType !== 2) {
        if (this.row.editTicketType.substr(0, 3) === 'G01' && !changeBrand) {
          this.row.editTicketRule = item.rule
          var buyItem = this.productsA.find(x => x.Detail.find(d => d.Code === item.buyItemCode)).Detail.find(d => d.Code === item.buyItemCode)
          if (item.saleItemCode !== '' && item.rule === 1) {
            var saleItem = this.productsB.find(x => x.Detail.find(d => d.Code === item.saleItemCode)).Detail.find(d => d.Code === item.saleItemCode)
          }
          if (item.rule === 1) {
            this.row.editProduct_A = buyItem
            this.row.editProduct_B = saleItem
          } else if (item.rule === 2 || item.rule === 3) {
            this.row.editProduct_A = buyItem
            this.row.editSaleDiscount = item.buyDiscount
          } else if (item.rule === 4) {
            this.row.editProduct_A = buyItem
            this.row.editProduct_B = buyItem
            this.row.editSaleDiscount = item.saleDiscount
          }
        } else {
          this.row.editUseAmount = item.useAmount
        }
      }
    },
    onSubmit () {
    },
    edit () {
      if (this.modelTab === 0) {
        if (this.checkModelType === 2) {
          this.update(1)
        } else {
          if (this.row.editSaleDay_E !== '' && this.row.editSaleDay_E < this.nowDate()) {
            this.updateForDelete()
          } else {
            this.update(0)
          }
        }
      } else if (this.modelTab === 1) {
        this.updateForDisabled()
      }
    },
    update (status) {
      var days = Number(this.row.editTicketSpeciesDay)
      var amount = Number(this.row.editTicketSpeciesQty)
      var applicablestartat = ''
      var applicableendat = ''
      var free = false

      var limitQty = 0
      var limitType = 0

      if (Number(this.row.editTicketSpecies) === 1) {
        amount = 0
      } else if (Number(this.row.editTicketSpecies) === 2) {
        days = 0
        applicablestartat = this.row.editUseDay_S.replace(/-/g, '')
        applicableendat = this.row.editUseDay_E.replace(/-/g, '')
        free = this.row.isFree

        limitType = Number(this.row.editTicketBuy)
        if (limitType === 1) {
          limitQty = 1
        } else if (limitType === 2) {
          limitQty = Number(this.row.editTicketBuyQty)
        }
      }

      var discount = 0
      var text = ''
      if (this.row.editTicketType.substr(0, 3) === 'G01') {
        text = this.row.editText
      } else if (this.row.editTicketType.substr(0, 3) === 'A01') {
        discount = Number(this.row.editMoney)
      } else if (this.row.editTicketType.substr(0, 3) === 'C01') {
        discount = parseFloat(this.row.editMoney)
      }
      var rule = 0
      var buyItem = ''
      var buyDisc = 0
      var saleItem = ''
      var saleDisc = 0
      var useAmo = 0
      if (this.row.editUseType === 1 || this.row.editUseType === '1' || this.row.editUseType === 3 || this.row.editUseType === '3') {
        if (this.row.editTicketType.substr(0, 3) === 'G01') {
          rule = Number(this.row.editTicketRule)
          if (rule === 1) {
            buyItem = this.row.editProduct_A.Code
            saleItem = this.row.editProduct_B.Code
          } else if (rule === 2 || rule === 3) {
            buyItem = this.row.editProduct_A.Code
            buyDisc = Number(this.row.editSaleDiscount)
          } else if (rule === 4) {
            buyItem = this.row.editProduct_A.Code
            saleItem = this.row.editProduct_A.Code
            saleDisc = parseFloat(this.row.editSaleDiscount)
          }
        } else {
          rule = 5
          useAmo = Number(this.row.editUseAmount)
        }
      }
      var updBrandCodes = ""
      if (this.row.editTicketType.substr(0,3)=='G01'){
        updBrandCodes = [this.row.queryBrandsCode]
      } else {
        updBrandCodes = this.row.selectBrands
      }
      var arrAll = {
        id: this.row.editId,
        appcategoryid: this.row.editAppType,
        name: this.row.editTicketName,
        poscategorycode: this.row.editTicketType,
        published: Number(this.row.editTicketSpecies),
        days: days,
        amount: amount,
        enabledat: this.row.editSaleDay_S.replace(/-/g, ''),
        disabledat: this.row.editSaleDay_E.replace(/-/g, ''),
        enabledatTime: this.row.editSaleDay_STime,
        disabledatTime: this.row.editSaleDay_ETime,
        applicablestartat: applicablestartat,
        applicableendat: applicableendat,
        bonus: Number(this.row.editPoint),
        discount: discount,
        text: text,
        comment: this.repl_content,
        status: Number(status),
        updatedAt: this.row.updatedAt.replace(/\//g, '').replace(/:/g, '').replace(/ /g, ''),
        free: free,
        week: this.row.week.toString(),
        limitType: limitType,
        limitQty: limitQty,
        useType: Number(this.row.editUseType),
        rule: rule,
        buyCode: buyItem,
        buyDiscount: buyDisc,
        saleCode: saleItem,
        saleDiscount: saleDisc,
        useAmount: useAmo,
        appSwap: this.row.appSwap,
        storeMode: Number(this.row.storeMode),
        storeList: (this.addStoreList.length > 0) ? this.addStoreList : [],
        useStartAt: (!this.row.useStartAt && !this.row.useEndAt) ? '' : (this.row.useStartAt.toString().padStart(2, '0') + ':00'),
        useEndAt: (!this.row.useStartAt && !this.row.useEndAt) ? '' : (this.row.useEndAt.toString().padStart(2, '0') + ':00'),
        dayMode: Number(this.row.dayMode),
        memo: this.row.memo,
        pointSubsidy: Number(this.row.pointSubsidy),
        brandCodes: updBrandCodes,
        allowTransfer: this.row.allowTransfer
      }
      let formData = new FormData()
      formData.append('image', this.file)
      formData.append('data', JSON.stringify(arrAll))
      var config = {
        headers: {
          'Content-Type': undefined
        }
      }
      this.$parent.Loading = true
      this.checkModelByCancel()
      return axios.post(API_URL + '/web/ticket/update', formData, config)
        .then((response) => {
          if (response.data.result === '0000') {
            var modelTab = this.$route.params.modelTab
            if (status === 1) {
              miniToastr.success('發佈成功')
              modelTab = 1
            } else {
              miniToastr.success('更新成功')
            }
            this.$router.push({name: 'coupon_exchange_list', params: {queryTab0: this.$route.params.queryTab0, querySaleNow: this.$route.params.querySaleNow, querySaleSchedule: this.$route.params.querySaleSchedule, queryTab1: this.$route.params.queryTab1, queryTab2: this.$route.params.queryTab2, collapse: this.$route.params.collapse, modelTab: modelTab}}).catch(() => {})
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    updateForDisabled () {
      var status = 1
      var disabledat = this.row.editSaleDay_E.replace(/-/g, '')
      if (this.row.editSaleDay_E < this.nowDate()) {
        status = 2
        disabledat = ''
      }
      this.$parent.Loading = true
      this.checkModelByCancel()

      var updBrandCodes = ""
      if (this.row.editTicketType.substr(0,3)=='G01'){
        updBrandCodes = [this.row.queryBrandsCode]
      } else {
        updBrandCodes = this.row.selectBrands
      }
      return axios.post(API_URL + '/web/ticket/updatedisabled',
        {
          id: this.row.editId,
          disabledat: disabledat,
          disabledatTime: this.row.editSaleDay_ETime,
          status: status,
          updatedAt: this.row.updatedAt.replace(/\//g, '').replace(/:/g, '').replace(/ /g, ''),
          comment: this.repl_content,
          week: this.row.week.toString(),
          name: this.row.editTicketName,
          storeMode: Number(this.row.storeMode),
          storeList: (this.addStoreList.length > 0) ? this.addStoreList : [],
          useStartAt: (!this.row.useStartAt && !this.row.useEndAt) ? '' : (this.row.useStartAt.toString().padStart(2, '0') + ':00'),
          useEndAt: (!this.row.useStartAt && !this.row.useEndAt) ? '' : (this.row.useEndAt.toString().padStart(2, '0') + ':00'),
          dayMode: Number(this.row.dayMode),
          memo: this.row.memo,
          pointSubsidy: Number(this.row.pointSubsidy),
          brandCodes: updBrandCodes,
          allowTransfer: this.row.allowTransfer
        })
        .then((response) => {
          if (response.data.result === '0000') {
            if (status === 2) {
              miniToastr.success('下架成功')
            } else {
              miniToastr.success('更新成功')
            }
            this.$router.push({ name: 'coupon_exchange_list', params: {queryTab0: this.$route.params.queryTab0, querySaleNow: this.$route.params.querySaleNow, querySaleSchedule: this.$route.params.querySaleSchedule, queryTab1: this.$route.params.queryTab1, queryTab2: this.$route.params.queryTab2, collapse: this.$route.params.collapse, modelTab: this.$route.params.modelTab} })
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    updateForDelete () {
      this.$parent.Loading = true
      this.checkModelByCancel()
      return axios.post(API_URL + '/web/ticket/delete',
        {
          id: this.row.editId,
          updatedAt: this.row.updatedAt.replace(/\//g, '').replace(/:/g, '').replace(/ /g, '')
        })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('草稿刪除成功')
            this.$router.push({ name: 'coupon_exchange_list', params: {queryTab0: this.$route.params.queryTab0, querySaleNow: this.$route.params.querySaleNow, querySaleSchedule: this.$route.params.querySaleSchedule, queryTab1: this.$route.params.queryTab1, queryTab2: this.$route.params.queryTab2, collapse: this.$route.params.collapse, modelTab: this.$route.params.modelTab} })
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    nowDate: function () {
      var time = new Date()
      var year = time.getFullYear()
      var month = time.getMonth() + 1
      var day = time.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (day >= 0 && day <= 9) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    checkWeek: function () {
      if (this.row.editSaleDay_S !== '' && this.row.editSaleDay_E !== '' && this.row.editSaleDay_S <= this.row.editSaleDay_E) {
        var diffDay = this.DateDiff(this.row.editSaleDay_E, this.row.editSaleDay_S)
        if (diffDay < 7) {
          var nowWeeks = ''

          for (let index = 0; index <= diffDay; index++) {
            var checkDate = new Date(this.row.editSaleDay_S)
            nowWeeks += new Date(checkDate.setDate(checkDate.getDate() + index)).getDay()
          }

          for (let index = 0; index < this.row.week.length; index++) {
            if (nowWeeks.indexOf(this.row.week[index]) < 0) {
              return false
            }
          }
        }
      }
      return true
    },
    DateDiff: function (sDate1, sDate2) {
      var oDate1, oDate2, iDays
      oDate1 = new Date(sDate1)
      oDate2 = new Date(sDate2)
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24)
      return iDays
    },
    edithandleFileChange (e) {
      let inputDOM = this.$refs.editinputer
      this.file = inputDOM.files[0]
      this.$emit('input', this.file)
      this.fileName = this.file.name
      if (!this.editimgPreview(this.file)) {
        this.$refs.editinputer.value = ''
        this.row.editdataUrl = undefined
      }
    },
    editimgPreview (file) {
      var rtn = false
      let self = this
      if (!file || !window.FileReader) return
      if (/^image/.test(file.type)) {
        if (file.size > fileUploadMaxSize) {
          miniToastr.error('圖檔大小不可超過 5MB')
        } else {
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onloadend = function () {
            self.row.editdataUrl = this.result
          }
          rtn = true
        }
      } else {
        miniToastr.error('請選擇正確圖檔')
      }
      return rtn
    },
    checkModelByOpen (type) {
      this.checkModelType = type
      if (this.checkModelType === 1) {
        if (this.row.editSaleDay_E !== '' && this.row.editSaleDay_E < this.nowDate()) {
          if (this.modelTab === 0) {
            this.checkModelTitle = '刪除草稿'
          } else {
            this.checkModelTitle = '下架'
          }
          this.$refs.checkModel.show()
          return
        } else {
          this.checkModelTitle = '編輯'
        }
      } else if (this.checkModelType === 2) {
        this.checkModelTitle = '發佈'
      }

      if (this.modelTab === 0) {
        if (this.row.editSaleDay_S !== '' && this.row.editSaleDay_S < this.nowDate() && this.row.appSwap === true) {
          this.v_SaleDayMsg = '起始日不可小於系統日'
        } else if (this.row.editSaleDay_S !== '' && this.row.editSaleDay_E !== '' && this.row.editSaleDay_S > this.row.editSaleDay_E) {
          this.v_SaleDayMsg = '起始日不可大於結束日'
        } else {
          this.v_SaleDayMsg = ''
        }
      }
      // 檢核兌換期間
      if (Number(this.row.editTicketSpecies) === 2) {
        if (this.modelTab === 0) {
          if (this.row.editUseDay_S !== '' && this.row.editUseDay_E !== '' && this.row.editUseDay_S > this.row.editUseDay_E) {
            this.v_UseDayEMsg = '結束日不可小於起始日'
          } else {
            if (this.row.editUseDay_S !== '' && this.row.editUseDay_S < this.row.editSaleDay_S) {
              this.v_UseDayMsg = '起始日不可小於上架日'
            } else {
              this.v_UseDayMsg = ''
            }
          }
        }
        if (this.row.editSaleDay_E !== '' && this.row.editUseDay_E !== '' && this.row.editUseDay_E < this.row.editSaleDay_E) {
          this.v_SaleDayEMsg = '上架結束日不可超過兌換期間'
        } else {
          this.v_SaleDayEMsg = ''
        }
      }
      if (this.file !== undefined && (this.row.editdataUrl === '' || this.row.editdataUrl === undefined)) {
        this.v_dataUrlMsg = '請選擇上傳圖片'
      } else {
        this.v_dataUrlMsg = ''
      }
      if (Number(this.row.editTicketSpecies) === 2 && Number(this.row.editTicketBuy) === 2 && this.row.editTicketBuyQty !== '') {
        if (Number(this.row.editTicketBuyQty) <= 0 || Number.isInteger(Number(this.row.editTicketBuyQty)) === false) {
          this.v_editTicketBuyQtyMsg = '值必須大於0且為整數'
        } else if (Number(this.row.editTicketBuyQty) > 99999 || Number.isInteger(Number(this.row.editTicketBuyQty)) === false) {
          this.v_editTicketBuyQtyMsg = '值不可超過99,999且為整數'
        } else if (this.row.editTicketSpeciesQty !== '' && Number(this.row.editTicketBuyQty) > Number(this.row.editTicketSpeciesQty)) {
          this.v_editTicketBuyQtyMsg = '限購張數不可大於販售總數'
        } else {
          this.v_editTicketBuyQtyMsg = ''
        }
      } else {
        this.v_editTicketBuyQtyMsg = ''
      }
      if (Number(this.row.editTicketSpecies) === 1 && this.row.editTicketSpeciesDay !== '' && (Number(this.row.editTicketSpeciesDay) <= 0 || Number.isInteger(Number(this.row.editTicketSpeciesDay)) === false)) {
        this.v_editTicketSpeciesDayMsg = '值必須大於0且為整數'
      } else if (Number(this.row.editTicketSpecies) === 1 && this.row.editTicketSpeciesDay !== '' && (Number(this.row.editTicketSpeciesDay) > 99999 || Number.isInteger(Number(this.row.editTicketSpeciesDay)) === false)) {
        this.v_editTicketSpeciesDayMsg = '值不可超過99,999且為整數'
      } else {
        this.v_editTicketSpeciesDayMsg = ''
      }
      if (Number(this.row.editTicketSpecies) === 2 && this.row.editTicketSpeciesQty !== '' && (Number(this.row.editTicketSpeciesQty) <= 0 || Number.isInteger(Number(this.row.editTicketSpeciesQty)) === false)) {
        this.v_editTicketSpeciesQtyMsg = '值必須大於0且為整數'
      } else if (Number(this.row.editTicketSpecies) === 2 && this.row.editTicketSpeciesQty !== '' && (Number(this.row.editTicketSpeciesQty) > 99999 || Number.isInteger(Number(this.row.editTicketSpeciesQty)) === false)) {
        this.v_editTicketSpeciesQtyMsg = '值不可超過99,999且為整數'
      } else {
        this.v_editTicketSpeciesQtyMsg = ''
      }

      this.v_Product_A = ''
      this.v_Product_B = ''
      this.v_SaleDiscount = ''
      this.v_useAmount = ''
      if (this.row.editTicketType.substr(0, 3) !== 'G01') {
        if (this.row.editTicketType.substr(0, 3) === 'C01' && this.row.editMoney !== '' && (parseFloat(this.row.editMoney) > 1 || parseFloat(this.row.editMoney) < 0.01 || this.row.editMoney.toString().split('.').length > 2 || (this.row.editMoney.toString().split('.').length >= 2 && this.row.editMoney.toString().split('.')[1].length > 2))) {
          this.v_editMoneyMsg = '請輸入0.01~1的數值(小數最多兩位)'
        } else if (this.row.editTicketType.substr(0, 3) === 'A01' && this.row.editMoney !== '' && (Number(this.row.editMoney) > 9999 || Number.isInteger(Number(this.row.editMoney)) === false)) {
          this.v_editMoneyMsg = '值不可超過9,999且為整數'
        } else {
          this.v_editMoneyMsg = ''
        }
        if (this.row.editUseType !== 2 && this.row.editTicketType !== 'A014') {
          // 滿額使用
          if (Number(this.row.editUseAmount) <= 0 || Number.isInteger(Number(this.row.editUseAmount)) === false) {
            this.v_useAmount = '請輸入1~9,999的整數'
          }
        }
      } else {
        this.checkSaleDiscount(true)
        this.v_editMoneyMsg = ''
      }
      if (this.row.appSwap === true) {
        if (this.row.editPoint !== '' && !(Number(this.row.editTicketSpecies) === 2 && this.row.isFree) && (Number(this.row.editPoint) <= 0 || Number.isInteger(Number(this.row.editPoint)) === false)) {
          this.v_editPointMsg = '值必須大於0且為整數'
        } else if (this.row.editPoint !== '' && (Number(this.row.editPoint) > 99999 || Number.isInteger(Number(this.row.editPoint)) === false)) {
          this.v_editPointMsg = '值不可超過99,999且為整數'
        } else {
          this.v_editPointMsg = ''
        }
      } else {
        this.v_editPointMsg = ''
      }
      if (!this.row.week || this.row.week.length <= 0) {
        this.v_editWeekMsg = '請至少勾選一個週期'
      } else {
        if (!this.checkWeek()) {
          this.v_editWeekMsg = '勾選的週期不在上架區間中，請重新確認'
        } else {
          this.v_editWeekMsg = ''
        }
      }
      // 檢核使用模式
      const mode = Number(this.row.storeMode)
      if (mode === 1 && this.addStoreAmount < 1) {
        this.v_StoreMode = '尚未選取使用門市'
      } else {
        this.v_StoreMode = ''
      }
      // 檢核使用期間
      this.row.useStartAt = Number(this.row.useStartAt)
      this.row.useEndAt = Number(this.row.useEndAt)
      if (this.row.useStartAt > 24 || this.row.useStartAt < 0 || this.row.useEndAt > 24 || this.row.useEndAt < 0) {
        this.v_UseTime = '請輸入0 至 24 之間數值'
      } else if (this.row.useEndAt !== 0 && this.row.useStartAt !== 0 && this.row.useStartAt === this.row.useEndAt) {
        this.v_UseTime = '起始時間不得等於結束時間'
      } else {
        this.v_UseTime = ''
      }

      if (Array.from(this.row.memo.trim()).length > 8) {
        this.v_Memo = '輸入文字超過八個字'
      } else {
        this.v_Memo = ''
      }

      if (Number(this.row.storeMode)=== 0 && this.row.selectBrands.length == 0 && this.row.editTicketType.substr(0,3)!=='G01') {
        this.v_BrandMsg = '請勾選品牌'
      } else {
        this.v_BrandMsg = ''
      }

      if (this.formstate.$invalid || this.v_SaleDayMsg !== '' || this.v_UseDayMsg !== '' || this.v_UseDayEMsg !== '' ||
          this.v_dataUrlMsg !== '' || this.v_editTicketSpeciesQtyMsg !== '' || this.v_editMoneyMsg !== '' ||
          this.v_editPointMsg !== '' || this.v_editTicketSpeciesDayMsg !== '' || this.v_editWeekMsg !== '' ||
          this.v_SaleDayEMsg !== '' || this.v_Product_A !== '' || this.v_Product_B !== '' || this.v_SaleDiscount !== '' ||
          this.v_useAmount !== '' || this.v_UseTime !== '' || this.v_Memo !== '' || this.v_StoreMode !== '' || this.v_BrandMsg !== '') {
        this.$parent.verificationErrMsg()
      } else {
        this.$refs.checkModel.show()
      }
    },
    onChangeTicketType: function () {
      if (this.row.editTicketType.substr(0, 3) === 'G01') {
        this.row.editTicketRule = ''
      } else {
        this.row.editTicketRule = '5'
      }
    },
    checkModelByCancel () {
      this.$refs.checkModel.hide()
    },
    getpost () {

      this.$parent.Loading = true
      var nowBrandCodes = []
      if (this.row.editTicketType.substr(0,3)=='G01'){
        nowBrandCodes = [this.row.queryBrandsCode]
      } else {
        nowBrandCodes = this.row.selectBrands
      }
      return axios.post(API_URL + '/web/shopping/getallstoresTowLevel/v1', {
        brandCode: nowBrandCodes
      })
        .then((response) => {
          if (response.data.result === '0000') {
            const mapCityList = new Map()
            const mapSelected = new Map()

            response.data.data.forEach(item => {
              mapCityList.set(item.City, item.Stores.map(store => {
                store.City = item.City
                return store
              }))
              mapSelected.set(item.City, [])
            })

            this.citylist = mapCityList
            this.selectedCityList = mapSelected
            //this.cityChange()
            this.$store.commit('TOKEN', response.data.jwt)

            // 更新已新增門市清單
            const storeCodeList = this.addStoreList.map(store => store.Code)
            this.addStoreList = []
            this.citylist.forEach((stores, city) => {
              stores.forEach((store) => {
                if (storeCodeList.includes(store.Code)) {
                  let storeObj = {...store} // copy object
                  this.addStoreList.push(storeObj)
                  this.selectedCityList.get(city).push(storeObj)
                }
              })
              this.citylist.set(city, this.citylist.get(city).filter(store => !storeCodeList.includes(store.Code)))
            })
            this.cityChange()
            this.getAddStoreList(1)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log(error)
          miniToastr.error(error.message, '資料讀取異常')
          this.$parent.Loading = false
        })
    },
    cityChange () {
      var city = this.city
      var plist = []
      if (this.citylist.has(city)) {
        this.citylist.get(city).sort((a, b) => a.ID - b.ID)
        plist = [...this.citylist.get(city)]
      }
      if (city.trim() !== '' && plist.length !== 0) {
        plist.unshift({
          Code: 'ALL',
          ID: 0,
          Name: city + '全門市'
        })
      }
      this.updateSelectedCity()
      this.storelist = plist
      this.store = ''
    },
    handleAddStore () {
      if (this.store) {
        if (this.store.ID === 0) { // 新增該地區全門市
          // 新增至儲存的門市列表
          this.addStoreList = [...this.citylist.get(this.city), ...this.addStoreList]
          // 更新已選擇門市列表
          this.selectedCityList.set(this.city, [...this.selectedCityList.get(this.city), ...this.citylist.get(this.city)])
          // 更新門市列表為空
          this.citylist.set(this.city, [])
        } else { // 新增該地區單一門市
          let storeObj = {...this.store} // copy object
          delete storeObj.Seq // delete sequence number
          // 新增至儲存的門市列表
          this.addStoreList.unshift(storeObj)
          // 更新門市列表刪除所選選項
          const newArr = this.citylist.get(this.city).filter(store => store.ID !== this.store.ID)
          this.citylist.set(this.city, newArr)
          // 更新已選擇門市列表新增所選選項
          this.selectedCityList.get(this.city).push(storeObj)
        }
      }
      this.cityChange()
      this.getAddStoreList(1)
    },
    handleDelStore (storeID) {
      this.addStoreList.forEach((item, index) => {
        if (item.ID === storeID) {
          this.addStoreList.splice(index, 1)
        }
      })
      this.selectedCityList.forEach((stores, city) => {
        if (stores.length > 0) {
          stores.forEach((store, storeIndex) => {
            if (store.ID === storeID) {
              this.citylist.get(city).push({...this.selectedCityList.get(city).splice(storeIndex, 1)[0]})
            }
          })
        }
      })
      this.cityChange()
      this.getAddStoreList(this.model1.currentPage)
    },
    refreshAddStoreAmount () {
      this.addStoreAmount = this.addStoreList.length
      const mode = Number(this.row.storeMode)
      if (this.addStoreAmount > 0) {
        if (mode !== 1) {
          this.showStoreWord = `已排除${this.selectedCity.length}個地區${this.addStoreAmount}間門市`
        } else if (mode === 1) {
          this.v_StoreMode = ''
          this.showStoreWord = `已新增${this.selectedCity.length}個地區${this.addStoreAmount}間門市`
        }
      } else {
        if (mode !== 1) {
          this.showStoreWord = '新增排除門市'
        } else if (mode === 1) {
          this.showStoreWord = '新增使用門市'
        }
      }
    },
    getAddStoreList (currentPage) {
      this.refreshAddStoreAmount()
      this.model1.currentPage = currentPage
      this.model1.totalrows = this.addStoreAmount
      const startIndex = (this.model1.currentPage - 1) * this.model1.rows
      const endIndex = this.model1.currentPage * this.model1.rows
      if (!this.addStoreList[startIndex] && this.addStoreAmount > 0) {
        this.getAddStoreList(currentPage - 1)
        return
      }
      let storesArray
      if (endIndex < this.addStoreAmount) {
        storesArray = this.addStoreList.slice(startIndex, endIndex)
      } else {
        storesArray = this.addStoreList.slice(startIndex)
      }
      this.showStoreList = JSON.parse(JSON.stringify(storesArray)) // 複製物件否則底下Seq將影響原陣列內部之物件
      this.showStoreList.forEach((item, index) => {
        item.Seq = startIndex + index + 1
      })
      this.model1.startRowNum = (this.addStoreAmount === 0) ? 0 : startIndex + 1
      this.model1.endRowNum = (this.addStoreAmount === 0) ? 0 : (this.addStoreAmount < endIndex) ? this.addStoreAmount : endIndex
    },
    handleStoreModeChange () {
      this.v_BrandMsg = ''
      this.row.selectBrands = []
      this.addStoreList = [] // reset the list
      this.getpost()
      this.getAddStoreList(1)
      const mode = Number(this.row.storeMode)
      if (mode !== 1 ) {
        this.showStoreWord = '新增排除門市'
      } else if (mode === 1) {
        this.showStoreWord = '新增使用門市'
      }
    },
    handleResetStore () {
      this.handleStoreModeChange()
    },
    handleFileUpload: async function () {
      let invalid = false
      const file = this.$refs.fileInput.files[0]
      if (file.size > 1024 * 1024 * 1 || file.name.slice(-4) !== '.csv') {
        miniToastr.error('請確認門市清單')
        invalid = true
      }
      const reader = new FileReader()
      reader.readAsText(file)
      const frdDoneEvent = await new Promise(resolve => { reader.onload = resolve })
      // 過濾換行符號、空白、及空的元素後並篩掉重複數值
      const uploadStores = [...new Set(frdDoneEvent.target.result.split('\n').map(item => item.trim()).filter(Boolean))]
      const maxStoreUploadAmount = 2000 // 上限
      if (uploadStores.length > maxStoreUploadAmount) {
        miniToastr.error('請確認門市清單格式')
        invalid = true
      }

      // Add store
      this.citylist.forEach((stores, city) => {
        stores.forEach((store) => {
          if (uploadStores.includes(store.Code)) {
            let storeObj = {...store} // copy object
            this.addStoreList.unshift(storeObj)
            this.selectedCityList.get(city).push(storeObj)
          }
        })
        this.citylist.set(city, this.citylist.get(city).filter(store => !uploadStores.includes(store.Code)))
      })

      if (invalid) {
        miniToastr.error('檔案解析失敗')
      } else {
        miniToastr.success('檔案解析成功')
        this.cityChange()
        this.getAddStoreList(1)
      }
      // 清空檔案所以允許多次上傳
      document.getElementById('storeList').value = null
    },
    updateSelectedCity () {
      if (this.addStoreList.length > 0) {
        this.selectedCity = [...new Set(this.addStoreList.map(store => store.City))]
      } else {
        this.selectedCity = []
      }
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: false
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    addStoreShow () {
      if (this.row.editTicketType.substr(0,3)!=='G01' && Number(this.row.storeMode)=== 0 && this.row.selectBrands.length == 0) {
        this.v_BrandMsg = '請勾選品牌'
        return
      } else {
        this.v_BrandMsg = ''
      }

      this.$refs.addStore.show()
      this.getpost()
    },
    onQueryBrandsCodeChange () {
      var params = this.$route.params
      var hasDelete = false
      if (params.modelTab !== 0) {
        hasDelete = true
      }
      this.row.editProduct_A=''
      this.row.editProduct_B=''
      this.getAllProductsA(hasDelete,true)
      this.addStoreList=[]
      this.getAddStoreList(1)
    },
    onTicketTypeChange () {
      this.v_editMoneyMsg='';
      this.addStoreList = [] // reset the list
      this.getAddStoreList(1)
      if (this.row.editTicketType.substr(0,3)=='G01' && this.row.storeMode==2){
        this.row.storeMode=0
      }
      if (this.row.editTicketType.substr(0,3)=='C01'){
        this.row.editUseType=3
      } else {
        this.row.editUseType=1
      }
    },
  },
  computed: {
    placeholderText () {
      return (!this.city || this.storelist.length) ? '請選擇' : '已全數選擇完畢'
    },
    isDisable () {
      return (!this.city || this.storelist.length === 0)
    }
  }
}

</script>

<style scoped>
.upload_block {
  position: relative;
  width: 220px;
  height: 140px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background: #f1f1f1;
  border: 3px dashed #d6d4d4;
}
.upload_input {
  display: none;
}
.upload_img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}
.upload_icon {
  font-weight: bold;
  font-size: 200%;
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  top: 35%;
}

.cursor_add_store {
  cursor: pointer;
}

.cursor_add_store:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/pages/coupon/exchange/Edit.vue